import React, { lazy, Suspense, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import navigationKasirConfig from "configs/NavigationKasirConfig";
import { KASIR_PREFIX_PATH } from "configs/AppConfig";
import { handleGet } from "redux/actions/baseAction";

import AddPinjamanPOS from "./pinjaman-pos/add";

export const KasirViews = () => {
  useEffect(() => {
    handleGet("pos/pos/cashier/location", (res) => {
      localStorage.setItem("statusClosing", res.is_open ? "OPEN" : "CLOSE");
    });
  }, []);

  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route
          exact
          path={`${KASIR_PREFIX_PATH}/pinjaman-pos/add`}
          component={AddPinjamanPOS}
        />

        <Route
          exact
          path={`${KASIR_PREFIX_PATH}/master-item`}
          component={lazy(() => import("./master-item/index"))}
        />

        <Route
          exact
          path={`${KASIR_PREFIX_PATH}/pinjaman-pos/detail/:id`}
          component={lazy(() => import("./pinjaman-pos/detail"))}
        />

        {navigationKasirConfig.map((res, i) => {
          return (
            <Route
              key={i}
              path={res.path}
              component={lazy(() => import("./" + res.key + "/index"))}
            />
          );
        })}

        <Route
          path={`${KASIR_PREFIX_PATH}/delivery-detail/:id`}
          component={lazy(() => import("./delivery/detail/index"))}
        />
      </Switch>
    </Suspense>
  );
};

export default React.memo(KasirViews);
